export default __webpack_public_path__ + "b871477.png";